import * as R from 'ramda';

export const CURRENT_LOCATION_ID = -1;

export const SORT_BY = {
  DISTANCE: { label: 'Distance', value: 'distance' },
  WAIT_TIMES: { label: 'Wait Times', value: 'wait-times' },
};

export const MAX_WAIT_TIMES_DISTANCE = 100;

export const SORT_BY_TOOLTIP = {
  SWIFT_PLUS_REQUIRED: 'Enroll in Swift+ in the Terminals Overview page to see Rack Wait Times.',
  WAIT_TIMES_RESTRICTION: `Wait Times sorting is restricted to a ${MAX_WAIT_TIMES_DISTANCE} mile radius from users' location.`,
};

const milesFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
  style: 'unit',
  unit: 'mile',
});

export const formatTerminalLocatorMileage = mileage => {
  return R.isNil(mileage) || Number.isNaN(mileage) ? '- -' : milesFormatter.format(mileage);
};

export const busyStatusWeight = status => {
  const weights = {
    'Less Busy': 0,
    Normal: 1,
    Unknown: 3,
    'Very Busy': 2,
  };
  return weights[status] ?? 3; // Default to Unknown weight if status not found
};
